import React from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import { ModalWrapper } from 'components';

class DialogModal extends React.PureComponent {
	static propTypes = {
		t: PropTypes.func,
		onClickYes: PropTypes.func.isRequired,
		onClickCancel: PropTypes.func.isRequired,
		title: PropTypes.string,
		okButtonTitle: PropTypes.string,
		hideCancel: PropTypes.bool,
		children: PropTypes.oneOfType([
			PropTypes.element,
			PropTypes.arrayOf(PropTypes.element)
		])
	}

	render() {
		const {
			onClickYes,
			onClickCancel,
			title,
			children,
			t,
			hideCancel,
			okButtonTitle
		} = this.props;
		return (
			<div className="flex justify-around items-center h-screen w-screen fixed left-0 top-0 z-20 py-16 bg-modalBackdrop">
				<ModalWrapper
					className="overflow-y-auto"
					onClickOutside={onClickCancel}>
					<div className="rounded bg-white w-104">
						<div className="w-full h-8 flex justify-around items-center bg-gray-200 rounded-t text-sm font-header">
							<div>{title}</div>
						</div>
						<div className="w-full">{children}</div>
						<div className="flex flex-row justify-around items-center w-full pb-8 px-10">
							{!hideCancel && (
								<button
									type="button"
									className="rounded-full py-1 text-lightNavy font-headerbg-white border-2 border-solid border-lightNavy focus:outline-none w-28"
									onClick={onClickCancel}>
									{t('settings.dialog-cancel')}
								</button>
							)}
							<button
								type="button"
								className="rounded-full py-1 text-white bg-lightNavy font-header focus:outline-none w-28"
								onClick={onClickYes}>
								{okButtonTitle !== undefined && okButtonTitle !== null ? okButtonTitle : t('general.yes')}
							</button>
						</div>
					</div>
				</ModalWrapper>
			</div>
		);
	}
}

export default withTranslation()(DialogModal);
